import { lazy } from 'react';

export const LazyNewCancellationFlowPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--new-cancellation-flow-page" */ './new-cancellation-flow-page'
    ),
);
